<template>
    <div v-if="!isPreviousOrderCanceled && !isPreviousOrderExpired"
         class="vanguard-oops-button"
         v-html="localConfig !== null && localConfig.oopsButtonLabel || $t('all.defaultOopsButtonLabel')"
         @click.prevent="cancel">
    </div>
    <div v-else-if="isPreviousOrderCanceled" class="alert alert-info">{{ $t("form.orderCanceled") }}</div>
    <div v-else-if="isPreviousOrderExpired" class="alert alert-warning">{{ $t("all.expiredMessage") }}</div>
</template>
<script>
import {mapGetters} from 'vuex';
import * as mutations from '../store/mutations';

export default {
  computed: {
    ...mapGetters([
      'localConfig',
      'journeyConfig',
      'isPreviousOrderCanceled',
      'isPreviousOrderExpired'
    ])
  },
  methods: {
    cancel() {
      // Prompt user to confirm order cancellation
      if (!confirm(this.$t('all.cancelOrderConfirmMessage'))) { // eslint-disable-line no-alert
        return;
      }

      this.$store.commit(mutations.SET_CANCEL_PREVIOUS_ORDER, true);
    }
  }
};
</script>



// WEBPACK FOOTER //
// oops-button.vue?4880b1ea